import styled from "styled-components";
import { Form } from "formik";
import { CustomInput } from "../../components/DSInput/style";
import DSButton from "../../components/DSButton";
import { InputWrapper } from "../../components/InputWrapper";

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CommonSection = styled.div`
  margin-bottom: 24px;
`;

export const SectionTitle = styled.h4`
  font-size: 14px;
  background: #f1f0f0;
  color: #000;
  font-weight: 600;
  padding: 8px;
  width: 100%;
  margin-bottom: 16px;
`;

export const ClientInfoFieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 16px;
  & ${CustomInput} {
    color: #000;
  }
`;

const CustomForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FormWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const RangeTaxInput = styled.p`
  margin: 0;
  margin-top: -4px;
  font-size: 12px;
`;

const CheckboxWrapper = styled.div`
  margin-top: 30px;
  height: 43.14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SimulateButton = styled(DSButton)`
  margin-top: 30px;
  height: 43.14px;
`;

const FieldsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 16px;
  row-gap: 16px;
`;

export const InstallmentCalculator = {
  CustomForm,
  FormWrapper,
  SimulateButton,
  FieldsWrapper,
  CheckboxWrapper,
  RangeTaxInput,
};

const InfoGrid = styled.div`
  display: flex;
  gap: 16px;
`;

const InfoColumn = styled.div`
  p {
    margin-bottom: 16px;
  }
`;

export const InstallmentInformation = {
  InfoGrid,
  InfoColumn,
};

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`;
